export const uiSchema = (t, editing) => {
  return {
    id: {
      "ui:widget": "hidden",
    },
    reason: {
      "ui:autofocus": true,
    },
    activeFrom: {
      "ui:widget": "hidden",
    },
    activeTo: {
      "ui:widget": "hidden",
    },
    isActive: {
      "ui:widget": editing ? "toggle" : "hidden",
      "ui:options": {
        label: t("STATUS"),
        labels: [
          { label: t("ACTIVE"), value: true },
          { label: t("INACTIVE"), value: false },
        ],
      },
    },
  };
};
